import React from 'react'
import _ from 'lodash/fp'
import { connect } from 'react-redux'
import localStore from 'localforage'

import * as ProfileReducer from '../../reducers/profile'

import Register from './register/SimpleRegister'
import Landing from './Landing'

export const REFERRER_KEY = 'GLFR_OPEN_REFERRER'

const GLFROpen = props => {
  const searchParams = new URLSearchParams(_.get('location.search', props))
  const referrerFromUrl = searchParams.get('rf')

  React.useEffect(() => {
    const memberships = _.get('apolloUser.memberships', props.profile)
    const hasOpenMembership = _.reduce((inOpen, membership) => {
      const memId = _.get('membershipId', membership)
      const expiryDate = _.get('expiryDate', membership)
      return inOpen || (memId === 'GLFR_OPEN' && expiryDate <= Date.now())
    }, false, memberships)
    if (hasOpenMembership) {
      props.history.push(`/u/${props.profile.handle}/open`)
    }
  }, [props.profile, props.history])

  const isSignedIn = _.has('profile.id', props)

  React.useEffect(() => {
    if (referrerFromUrl) {
      localStore.setItem(REFERRER_KEY, referrerFromUrl)
    }
  }, [])

  const Page = getPageToShow(props.page)

  return (
    <div style={{ padding: 20, minHeight: 'calc(100vh - 64px)', maxWidth: 1280, margin: '0 auto' }}>
      <Page isSignedIn={isSignedIn} />
    </div>
  )
}

const getPageToShow = page => {
  switch (page) {
    case 'register': return Register
    default: return Landing
  }
}

export default _.compose(
  connect(
    s => {
      const profile = ProfileReducer.selectors.getProfile(s)
      return {
        profile
      }
    },
    d => {
      return {
        loadProfile: () => d(ProfileReducer.actions.loadRequest(Date.now()))
      }
    }
  )
)(GLFROpen)
